import { OvenMediaMediaEventsSource } from "../interfaces/subtitles";

// The publisher's media events as the Records tab shows them. The seventeen kinds are the
// middleware's `REPLAY_MEDIA_EVENT_KINDS`; a kind this version does not know is shown raw.

export const MEDIA_EVENT_KIND_LABELS: Record<string, string> = {
  media_added: "Source ajoutée" /* TRANSLATION */,
  media_removed: "Source retirée" /* TRANSLATION */,
  video_on: "Vidéo activée" /* TRANSLATION */,
  video_off: "Vidéo coupée" /* TRANSLATION */,
  audio_on: "Micro activé" /* TRANSLATION */,
  audio_off: "Micro coupé" /* TRANSLATION */,
  display_shown: "Flux affiché" /* TRANSLATION */,
  display_hidden: "Flux masqué" /* TRANSLATION */,
  stream_waiting: "Flux en attente" /* TRANSLATION */,
  stream_capturing: "Capture en cours" /* TRANSLATION */,
  stream_publishing: "Publication en cours" /* TRANSLATION */,
  stream_ready: "Flux prêt" /* TRANSLATION */,
  stream_stopped: "Flux arrêté" /* TRANSLATION */,
  stream_error: "Erreur de flux" /* TRANSLATION */,
  stream_no_video_track: "Pas de piste vidéo" /* TRANSLATION */,
  stream_no_audio_track: "Pas de piste audio" /* TRANSLATION */,
  stream_no_tracks: "Aucune piste" /* TRANSLATION */,
};

export const getMediaEventKindLabel = (kind: string): string => MEDIA_EVENT_KIND_LABELS[kind] ?? kind;

/** `mm:ss` from the record's start, `h:mm:ss` past an hour, a leading minus before the start. */
export const formatMediaEventOffset = (offsetMs?: number): string => {
  if (offsetMs === undefined || Number.isNaN(offsetMs)) return "—";
  const sign = offsetMs < 0 ? "−" : "";
  const total = Math.round(Math.abs(offsetMs) / 1000);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const mmss = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  return `${sign}${hours ? `${hours}:${mmss}` : mmss}`;
};

/** The header line of the events popup: where the events come from, and until when. */
export const formatMediaEventsSource = (source: OvenMediaMediaEventsSource, expireAt?: Date | string): string => {
  switch (source) {
    case "collection": {
      const expiry = expireAt ? new Date(expireAt) : undefined;
      return expiry && !Number.isNaN(expiry.getTime())
        ? `Source : base du serveur (expire le ${expiry.toLocaleDateString()} ${expiry.toLocaleTimeString()} ; une copie est gardée à côté de l'enregistrement)` /* TRANSLATION */
        : "Source : base du serveur" /* TRANSLATION */;
    }
    case "file":
      return "Source : la copie gardée à côté de l'enregistrement (la base du serveur a expiré)" /* TRANSLATION */;
    default:
      return "Aucun événement connu pour cet enregistrement" /* TRANSLATION */;
  }
};
